import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import type { ProductGroup } from '@/lib/data/products';

/**
 * Combines class names with conditional logic and merges Tailwind classes properly
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Prepares product groups for client-side use, ensuring data integrity.
 * The sorting is handled by the API, so this function primarily ensures a safe copy.
 * @param {ProductGroup[]} groups - The array of product groups from the API.
 * @returns {ProductGroup[]} A deep copy of the product groups.
 */
export function groupAndSortProductGroups(groups: ProductGroup[]): ProductGroup[] {
  // Return a deep copy to prevent mutations of the original data cache.
  return JSON.parse(JSON.stringify(groups));
}
